@if (isAction()) {
    <button
        type="button"
        [attr.aria-label]="navigationTitle()"
        [ngClass]="{ 'sb-sidebar-item': !isLinkActive(), 'sb-sidebar-item-active': isLinkActive() }"
        [attr.aria-expanded]="expanded()"
        [attr.aria-controls]="controls() || null"
        [attr.data-sb-qa]="navigationTitle()">
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </button>
} @else {
    <a
        #linkDir="linkForRouter"
        (mousedown)="ForceDefaultAnimation()"
        [attr.aria-label]="navigationTitle()"
        [ngClass]="{ 'sb-sidebar-item': !isLinkActive(), 'sb-sidebar-item-active': isLinkActive() }"
        [linkForRouter]="routerLink()"
        [attr.aria-current]="isLinkActive() ? 'page' : null"
        [attr.data-sb-qa]="navigationTitle()"
        [fragment]="fragment()"
        [queryParams]="queryParams()">
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
}

<ng-template #itemContent>
    <div
        class="sb-sidebar-item-wrapper"
        [matTooltip]="navigationTitle()"
        [matTooltipDisabled]="disableTooltip() || ((textAlwaysVisible() || Scope.onLinkTextChange()) && !isLabelTruncated)"
        matTooltipPosition="right">
        <div class="sb-sidebar-item-icon-wrapper" aria-hidden="true">
            <lib-icon
                [icon]="icon()"
                [size]="isMobileOrTablet ? IconSize.Small : IconSize.Medium"></lib-icon>
        </div>
        @if (textAlwaysVisible() || Scope.onLinkTextChange()) {
            <span
                class="sb-sidebar-item-label"
                #labelEl>
                {{ navigationTitle() }}
            </span>
        }
        @if (badgeText()) {
            <lib-badge
                class="sb-sidebar-item-badge"
                [text]="badgeText()"
                [kind]="BadgeKind.Count"
                [color]="BadgeColor.OnBrand"></lib-badge>
        }
    </div>
</ng-template>
